@let allFacilities = (facilitiesOverviewService.facilities$ | async) ?? [];
@let isLoading = facilitiesOverviewService.loadingStatus() === LoadingState.LOADING;
@let visibleFacilities = allFacilities.slice(startIndex(), startIndex() + PAGE_SIZE);
@let canPrev = startIndex() > 0;
@let canNext = startIndex() + PAGE_SIZE < allFacilities.length;

<section class="panel facility-overview">
  <header class="facility-overview__header">
    <h2 class="facility-overview__title">
      {{ 'monitoring.dashboard.facilities-overview.title' | translate }}
    </h2>

    <div class="facility-overview__nav">
      <lib-icon-button
        (click)="showPrev()"
        [disabled]="!canPrev"
        icon="arrow-left"
        size="24"
        class="facility-overview__nav-btn"
      />
      <lib-icon-button
        (click)="showNext()"
        [disabled]="!canNext"
        icon="arrow-right"
        size="24"
        class="facility-overview__nav-btn"
      />
    </div>
  </header>

  <div class="facility-overview__list">
    @if (isLoading) {
      @for (skeleton of skeletons; track $index) {
        <div class="facility-overview__item">
          <div
            class="skeleton-card"
            [libSkeleton]="true"
          ></div>
        </div>
      }
    } @else {
      @for (facility of visibleFacilities; track facility.facilityId) {
        <div class="facility-overview__item">
          <div
            class="facility-overview__animation-wrapper"
            @fade
          >
            <mon-facility-overview-card
              [facility]="facility"
              [canOpenDevices]="canOpenDevices()"
            />
          </div>
        </div>
      }
    }
  </div>
</section>
